import React, { useRef, createRef, useEffect } from 'react'
import { Card, CardBody, Col, Collapse, Label, Row } from "reactstrap"
import moment from "moment"
import classnames from "classnames"
import { ScrollBehaviour } from './tableutils'
import { taskTotalHoursConversion } from 'helpers/util'

const HandlingAccordian = (props) => {
  const { datass, handleAccordion, handleOnclickAccordion, handleOnclickAccordionDate, handleAccordiondate, handleAccordionimage, handleOnclickAccordionImage, setisGallery, setphotoIndex, subcategory, accountIdfromParams, noLightBox } = props
  const getSubCategoryData = (datass || []).filter(item => item?.subcategoryId == subcategory)
  const findIndexOfAccountId = (getSubCategoryData[0]?.data || []).findIndex((item) => item.accountId == accountIdfromParams)
  const elementsRef = useRef(getSubCategoryData[0]?.data.map(() => createRef()));

  useEffect(() => {
    if (findIndexOfAccountId > -1) {
      setTimeout(() => {
        ScrollBehaviour(elementsRef?.current[findIndexOfAccountId])
      }, 1000)
    }

  }, [])


  return <>
    {datass?.map((items, keyId) => (
      <Card key={keyId}>
        <CardBody>
          <div className="accordion" id="accordion">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button
                  className={classnames("accordion-button", "fw-medium", {
                    collapsed: handleAccordion !== keyId,
                  })}
                  type="button"
                  onClick={() => handleOnclickAccordion(keyId)}
                  style={{ cursor: "pointer" }}
                >
                  <div>
                    <strong>Project: </strong>
                    {items.projectname} | {taskTotalHoursConversion(items.totalWorkedHours)}
                  </div>
                </button>
              </h2>

              <Collapse
                isOpen={handleAccordion === keyId}
                className="accordion-collapse"
              >
                <div className="accordion-body">
                  <div className="text-muted">
                    <div className="accordion" id="accordion">
                      <div className="accordion-item mb-1">
                        <h2 className="accordion-header" id="headingOne">
                          <button
                            className={classnames(
                              "accordion-button ",
                              "fw-medium",
                              {
                                collapsed: handleAccordiondate !== keyId,
                              }
                            )}
                            type="button"
                            onClick={() =>
                              handleOnclickAccordionDate(keyId)
                            }
                            style={{ cursor: "pointer" }}
                          >
                            <div>
                              <strong>
                                Date: {items.date} |{" "}
                                {taskTotalHoursConversion(items.totalWorkedHours)}
                              </strong>
                            </div>
                          </button>
                        </h2>

                        <Collapse
                          isOpen={handleAccordiondate === keyId}
                          className="accordion-collapse"
                        >
                          <div className="accordion-body">
                            <div className="text-muted">
                              {items.userHoursList.map((details, ids) => (
                                <div
                                  className="accordion"
                                  id="accordion"
                                  key={ids}
                                  ref={elementsRef?.current && elementsRef?.current[ids]}
                                >
                                  <div className="accordion-item mb-1">
                                    <h2
                                      className="accordion-header"
                                      id="headingOne"
                                    >
                                      <button
                                        className={classnames(
                                          "accordion-button",
                                          "fw-medium",
                                          {
                                            collapsed:
                                              handleAccordionimage !==
                                              ids,
                                          }
                                        )}
                                        type="button"
                                        onClick={() =>
                                          handleOnclickAccordionImage(ids)
                                        }
                                        style={{ cursor: "pointer" }}
                                      >
                                        {details.userName} |{" "}
                                        {taskTotalHoursConversion(details.workedhours)}
                                      </button>
                                    </h2>
                                    <Collapse
                                      isOpen={
                                        handleAccordionimage === ids
                                      }
                                      className="accordion-collapse"
                                    >
                                      {handleAccordionimage === ids && (
                                        <div className="accordion-body">
                                          <Row>
                                            {details.screenList.map(
                                              (img, ids) => (
                                                <Col
                                                  xl="2"
                                                  sm="4"
                                                  key={"_col_" + ids}
                                                >
                                                  <Card>
                                                    <CardBody>
                                                      <div
                                                        className="product-img position-relative d-flex"
                                                        style={{
                                                          boxShadow:
                                                            "0px 5px 15px grey",
                                                        }}
                                                      >
                                                        <img
                                                          src={
                                                            img?.imagePath
                                                          }
                                                          onClick={() => {
                                                            if(noLightBox){
                                                              window.open(img?.imagePath, '_blank');
                                                            }else{
                                                              setisGallery(
                                                                true
                                                              )
                                                              setphotoIndex(
                                                                ids
                                                              )
                                                            }
                                                          }}
                                                          className="img-fluid mx-auto d-block"
                                                          style={{
                                                            borderRadius:
                                                              "5px",
                                                          }}
                                                        />
                                                      </div>

                                                      <div className="mt-2 text-center">
                                                        {moment(
                                                          new Date(
                                                            img.capturetime
                                                          )
                                                        ).format(
                                                          "HH:mm:ss"
                                                        )}
                                                      </div>
                                                    </CardBody>
                                                  </Card>
                                                </Col>
                                              )
                                            )}
                                          </Row>
                                        </div>
                                      )}
                                    </Collapse>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </Collapse>
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        </CardBody>
      </Card>
    ))}
  </>
}

export default HandlingAccordian